<script setup lang="ts">
import IconLogo from 'assets/logo-full.svg';

const props = withDefaults(defineProps<{
  noBgr?: boolean;
  classes?: string;
  position?: 'center' | 'top';
  showAs?: 'popup' | 'page';
}>(), {
  noBgr: false,
  position: 'center',
  showAs: 'popup',
  classes: '',
});

const isBgr = computed(() => props.showAs === 'popup');
</script>

<template>
  <Teleport to="#teleports">
    <div
      class="absolute top-0 z-10 w-dvw h-dvh flex flex-col flex-nowrap gap-8 overflow-scroll items-center pointer-events-auto"
      :class="{
        ['bg-gray-800/30']: isBgr,
        [classes]: true,
      }"
    >
      <IconLogo
        v-if="showAs === 'page'"
        class="mt-16 w-[242px] h-[42px] shrink-0 cursor-pointer"
        @click="navigateTo('/')"
      />
      <div
        v-else
        class="mt-20"
      />

      <div
        class="h-fit  flex flex-col flex-nowrap justify-start"
      >
        <slot />
      </div>

      <slot name="bottom" />
    </div>
  </Teleport>
</template>

<style scoped>

</style>
